export function formatPrice(value) {
    const normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value
    const amount = Number.parseFloat(normalizedValue)

    if (Number.isNaN(amount)) {
        return value ? `${value} €` : '0,00 €'
    }

    return `${amount.toFixed(2).replace('.', ',')} €`
}

export function formatDisplayDate(value) {
    if (!value || value === 'Seleziona data') {
        return value
    }

    if (value instanceof Date) {
        const day = String(value.getDate()).padStart(2, '0')
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const year = String(value.getFullYear())
        return `${day}/${month}/${year}`
    }

    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (!match) {
        return value
    }

    return `${match[3]}/${match[2]}/${match[1]}`
}

export function formatDisplayDateTime(value) {
    if (!value) {
        return value
    }

    const [datePart, timePart] = String(value).split(' ')
    const formattedDate = formatDisplayDate(datePart)

    return timePart ? `${formattedDate} ${timePart}` : formattedDate
}
